const SCROLL_OFFSET = 50;

function scrollToElementById(id) {
  const element = document.getElementById(`title-${id}`) || document.getElementById(id);
  if (element) {
    const elementTop = element.getBoundingClientRect().top + window.pageYOffset;
    window.scrollTo({
      top: elementTop - SCROLL_OFFSET,
      behavior: 'smooth'
    });
  }
}

function scrollToHashElement() {
  const hash = window.location.hash;
  if (hash) {
    scrollToElementById(hash.slice(1));
  }
}

function handleAnchorClicks(event) {
  const link = event.target.closest('a[href^="#"]');
  if (link) {
    const targetId = link.getAttribute('href').slice(1);
    const targetElement = document.getElementById(`title-${targetId}`) || document.getElementById(targetId);
    if (targetElement) {        
      event.preventDefault();
      history.pushState(null, '', `#${targetId}`);
      scrollToElementById(targetId);
    }
  }
}

window.addEventListener('DOMContentLoaded', () => {
  scrollToHashElement();
  document.addEventListener('click', handleAnchorClicks);
});

window.addEventListener('beforeunload', (event) => {
  document.removeEventListener('click', handleAnchorClicks);
});